import TableHasPagenation from '../../../components/TableHasPagenation'
import { Tooltip } from 'antd'
import moment from 'moment'
import CheckItemOperateBtns from './CheckItemOperateBtns'
import { FreshList } from '../context'
import { checkBillStatusMap } from '../config'

export default function CheckListTable({
  pageData,
  getList,
  loading,
  setShowAdd,
  rowSelection,
  storeCode
}) {
  const BasicColumns = [
    {
      title: '序号',
      dataIndex: 'id',
      render: (t, r, index) =>
        (pageData.pageIndex - 1) * pageData.pageSize + index + 1
    },
    {
      title: '盘点单据',
      dataIndex: 'checkNo'
    },
    {
      title: '盘点名称',
      dataIndex: 'sheetName'
    },
    {
      title: '盘点时间',
      dataIndex: 'finishTime',
      render: val => moment(val).format('YYYY-MM-DD HH:mm')
    },
    {
      title: '盘点状态',
      dataIndex: 'checkStatus',
      render: text => checkBillStatusMap[text]
    },
    {
      title: '经手人',
      dataIndex: 'checkUserName'
    },
    {
      title: '备注',
      dataIndex: 'note',
      ellipsis: true
      // render: note => (
      //   <Tooltip placement='topLeft' title={note}>
      //     {note}
      //   </Tooltip>
      // )
    },
    {
      title: '操作',
      render: (text, record, index) => (
        <CheckItemOperateBtns
          setShowAdd={setShowAdd}
          storeCode={storeCode}
          getList={getList}
          record={record}
        />
      )
    }
  ]
  const fresh = () => getList(pageData)
  return (
    <FreshList.Provider value={{ fresh }}>
      <TableHasPagenation
        columns={BasicColumns}
        rowKey='checkNo'
        onPageSizeChange={getList}
        pageData={pageData}
        rowSelection={rowSelection}
        loading={loading}
      />
    </FreshList.Provider>
  )
}
